import { Icon, MenuToggle, Select, SelectList, SelectOption } from "@patternfly/react-core";
import React, { useState } from "react";

// see https://mui.com/material-ui/material-icons
import LightMode from "@mui/icons-material/LightMode";
import DarkMode from "@mui/icons-material/DarkMode";
import SystemMode from "@mui/icons-material/Computer";

export default function ThemeSwitcher({ theme }): React.ReactNode {
  const [isSelectionOpen, setIsSelectionOpen] = useState(false);

  const changeMode = (_event, newMode) => {
    theme.setMode(newMode);
    setIsSelectionOpen(false);
  };

  const effectiveMode = theme.mode === theme.modes.SYSTEM ? theme.resolvedTheme : theme.mode;
  const CurrentThemeIcon = effectiveMode === theme.modes.DARK ? DarkMode : LightMode;

  return (
    <Select
      isOpen={isSelectionOpen}
      selected={theme.mode}
      onSelect={changeMode}
      onOpenChange={setIsSelectionOpen}
      toggle={(toggleRef) => (
        <MenuToggle
          ref={toggleRef}
          onClick={() => setIsSelectionOpen(!isSelectionOpen)}
          isExpanded={isSelectionOpen}
          icon={
            <Icon size="lg">
              <CurrentThemeIcon sx={{ fontSize: 16 }} />
            </Icon>
          }
        />
      )}
      popperProps={{ position: "end" }}
      shouldFocusToggleOnSelect
    >
      <SelectList>
        <SelectOption value={theme.modes.SYSTEM} icon={<SystemMode fontSize="small" />}>
          System default ({theme.resolvedTheme === theme.modes.DARK ? "dark" : "light"})
        </SelectOption>
        <SelectOption value={theme.modes.LIGHT} icon={<LightMode />}>
          Light
        </SelectOption>
        <SelectOption value={theme.modes.DARK} icon={<DarkMode />}>
          Dark
        </SelectOption>
      </SelectList>
    </Select>
  );
}
